<div
  class="wrapper"
  fxLayout="column"
  [style.background-color]="headerBgColour"
  [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'"
>
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="padding-15 dialogTitle">
      {{ dialogTitle }}
    </div>
    <button
      mat-icon-button
      mat-dialog-close
      class="action-button"
      (click)="dialogClosed()"
      
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<mat-progress-bar *ngIf="showProgressBar" mode="determinate" [value]="percentProgress.value" class="green-progress">
</mat-progress-bar>

<div [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'" class="details-body mat-elevation-z4 padding-25">
  <div *ngIf="processError">
    <div fxLayout="column" fxLayoutAlign="center" >
      <h4 class="details-body-header text-center serverErrorMsg">{{ 'DRIVER_IMPORT.approvalProecssFailed' | translate }}</h4>

      <p class="text-center">
        {{ 'DRIVER_IMPORT.approvalServiceErrorMsg' | translate }}
      </p>
      <div class="action-buttons text-center" fxLayout="row" fxLayoutAlign="center center">
        <button (click)="confirm()" mat-button vrm-button>
          {{ 'DRIVER_IMPORT.ok' | translate }}
        </button>
      </div>
    </div>
    </div>
  <div>

  <vrm-import-job-status [jobStatus]="jobStatus"></vrm-import-job-status>

    <div class="import-warning" *ngIf="jobStatus === 'VALIDATED' && !details.bypassApproval">
      <p>
        <strong class="red-text">! {{ 'DRIVER_IMPORT.important' | translate | uppercase }}:</strong>
        {{ 'DRIVER_IMPORT.importantWarning' | translate }}
      </p>
      <p>
        {{ 'DRIVER_IMPORT.importantWarning2' | translate }}
      </p>
      <div class="action-buttons" fxLayout="row" fxLayoutAlign="space-between center">
        <button (click)="reject()" mat-button class="action-btn danger" [disabled]="showProgressBar">
          {{ 'DRIVER_IMPORT.reject' | translate | uppercase }}
        </button>
        <button (click)="approve()" mat-button vrm-button class="action-btn" [disabled]="showProgressBar">
          {{ 'DRIVER_IMPORT.approve' | translate | uppercase }}
        </button>
      </div>
    </div>
    
    <div class="import-warning" fxLayout="column" fxLayoutAlign="center" *ngIf="jobStatus === 'UPLOADED'">
      <h4 class="details-body-header text-center">{{ 'DRIVER_IMPORT.fileUploadCompleted' | translate }}</h4>
      <p class="text-center">
        {{ 'DRIVER_IMPORT.fileProcessingWillBegin' | translate }}
      </p>
    </div>

    <div class="import-warning" fxLayout="column" fxLayoutAlign="center" *ngIf="jobStatus === 'COMPLETED_WITH_PROVISION_ERROR'">
      <h4 class="details-body-header text-center">{{ 'DRIVER_IMPORT.processErrorTitle' | translate }}</h4>
      <p class="text-center">
        {{ 'DRIVER_IMPORT.processErrorMsg' | translate }}
      </p>
    </div>

    <div class="import-warning" fxLayout="column" fxLayoutAlign="center" *ngIf="jobStatus === 'COMPLETED_WITH_VALIDATION_ERROR'">
      <h4 class="details-body-header text-center">{{ 'DRIVER_IMPORT.validationErrorTitle' | translate }}</h4>
      <p class="text-center">
        {{ 'DRIVER_IMPORT.validationErrorMsg' | translate }}
      </p>
    </div>
    <div class="file-details" >

      <h4 class="details-body-header">{{ 'DRIVER_IMPORT.fileProcessApproval' | translate }}</h4>
      <table>
        <tbody>
          <tr>
            <td>{{ 'DRIVER_IMPORT.status' | translate}} :</td>
            <td class="padding-l-15"><span>{{ jobStatus }}</span></td>
          </tr>
          <tr>
            <td>{{ 'DRIVER_IMPORT.jobCreatedAt' | translate }} :</td>
            <td class="padding-l-15">
              <span>{{ jobCreatedAt }}</span>
            </td>
          </tr>
          <tr>
            <td>{{ 'DRIVER_IMPORT.jobId' | translate }} :</td>
            <td class="padding-l-15">
              <span>{{ jobId }}</span>
            </td>
          </tr>
          <tr>
            <td>{{ 'DRIVER_IMPORT.inputSource' | translate }} :</td>
            <td class="padding-l-15"><span>{{ details.source}}</span></td>
          </tr>
          <tr *ngIf="details.fileEndpoint.original">
            <td>{{ 'DRIVER_IMPORT.fileName' | translate }} : </td>
            <td class="padding-l-15">
              <span>{{ details.fileEndpoint.original.split('/').pop() }} </span>
              <a *ngIf="details.fileEndpoint.original" class="link" (click)="downloadFile(downloadFileType.Original)"> <i class="fas fa-save"></i> {{ 'DRIVER_IMPORT.link' | translate }} </a>
            </td>
          </tr>
          <tr *ngIf="details.source==='API'">
            <td>{{ 'DRIVER_IMPORT.userData' | translate }} :</td>
            <td class="padding-l-15">
              <a *ngIf="details.fileEndpoint.parsedUserData" class="link" (click)="downloadFile(downloadFileType.ParsedUserData)"> <i class="fas fa-save"></i> {{ 'DRIVER_IMPORT.link' | translate }} </a>
            </td>
          </tr>
          <ng-container *ngIf="jobStatus !== 'COMPLETED_AS_REJECTED' && details.approvedBy">
            <tr>
              <td>{{ 'DRIVER_IMPORT.approvedBy' | translate }} :</td>
              <td class="padding-l-15">
                <span>{{ approvedBy }}</span>
              </td>
            </tr>
            <tr>
              <td>{{ 'DRIVER_IMPORT.approvedOn' | translate }} :</td>
              <td class="padding-l-15">
                <span>{{ approvedAt }}</span>
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="jobStatus === 'COMPLETED_AS_REJECTED' && details.approvedBy">
            <tr>
              <td>{{ 'DRIVER_IMPORT.rejectedBy' | translate }} :</td>
              <td class="padding-l-15">
                <span>{{ approvedBy }}</span>
              </td>
            </tr>
            <tr>
              <td>{{ 'DRIVER_IMPORT.rejectedOn' | translate }} :</td>
              <td class="padding-l-15">
                <span>{{ approvedAt }}</span>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="jobStatus === 'COMPLETED_SUCCESSFULLY'">
            <td>{{ 'DRIVER_IMPORT.completedOn' | translate }} :</td>
            <td class="padding-l-15">
              <span>{{ details.completedAt }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="file-details" *ngIf="jobStatus !== 'INITIATED' && jobStatus !== 'UPLOADED'">
      <h4 class="details-body-header">{{ 'DRIVER_IMPORT.fileChangeDetails' | translate }}</h4>
      <p>{{ 'DRIVER_IMPORT.processingFileChanges' | translate }}</p>

      <div>
        <ng-container>
          <table>
            <tbody>
              <tr>
                <td>{{ 'DRIVER_IMPORT.existingDrivers' | translate }} :</td>
                <td class="padding-l-15">
                  <span class="red-text"> {{ existingUsersSnapshotCount }}</span>
                </td>
              </tr>
              <tr>
                <td>{{ 'DRIVER_IMPORT.recordsToBeAdded' | translate }} :</td>
                <td class="padding-l-15">
                  <span
                    >{{ usersToBeCreatedCount }} / <span [ngClass]="{ 'red-text': createdChangePercentage > colorChangeThreshold, 'green-text' : createdChangePercentage <= colorChangeThreshold }"
                      >{{ createdChangePercentage.toFixed(1) }}%</span
                    ></span
                  >
                  <a *ngIf="details.fileEndpoint.usersToBeCreated" class="link" (click)="downloadFile(downloadFileType.UsersToBeCreated)"> {{ 'DRIVER_IMPORT.link' | translate }} </a>
                </td>
              </tr>
              <tr>
                <td>{{ 'DRIVER_IMPORT.recordsToBeUpdated' | translate }} :</td>
                <td class="padding-l-15">
                  <span
                    >{{ usersToBeUpdatedCount }} / <span [ngClass]="{ 'red-text': updatedChangePercentage > colorChangeThreshold, 'green-text' : updatedChangePercentage <= colorChangeThreshold }"
                      >{{ updatedChangePercentage.toFixed(1) }}%</span
                    ></span
                  >
                  <a *ngIf="details.fileEndpoint.usersToBeUpdated" class="link" (click)="downloadFile(downloadFileType.UsersToBeUpdated)"> {{ 'DRIVER_IMPORT.link' | translate }} </a>
                </td>
              </tr>
              <tr>
                <td>{{ 'DRIVER_IMPORT.recordsToBeRemoved' | translate }} :</td>
                <td class="padding-l-15">
                  <span
                    >{{ usersToBeDeletedCount }} / 
                    <span [ngClass]="{ 'red-text': deletedChangePercentage > colorChangeThreshold, 'green-text' : deletedChangePercentage <= colorChangeThreshold }">
                      {{ deletedChangePercentage.toFixed(1) }}%</span
                    ></span
                  >
                  <a *ngIf="details.fileEndpoint.usersToBeDeleted" class="link" (click)="downloadFile(downloadFileType.UsersToBeDeleted)"> {{ 'DRIVER_IMPORT.link' | translate }} </a>
                </td>
              </tr>

              <tr>
                <td>{{ 'DRIVER_IMPORT.recordsTotal' | translate }}:</td>
                <td class="padding-l-15">
                  <span class="red-text"> {{ totalRecordsCount }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
      </div>
    </div>


    <!-- File Validation Section -->
    <div class="file-validation" *ngIf="jobStatus === 'COMPLETED_WITH_VALIDATION_ERROR'">
      <h4 class="details-body-header">{{ 'DRIVER_IMPORT.fileValidation' | translate }}</h4>
      <table>
        <tbody>
          <tr>
            <td>{{ 'DRIVER_IMPORT.status' | translate }} :</td>
            <td class="padding-l-15">
              <span>{{ 'DRIVER_IMPORT.failed' | translate }}</span>
            </td>
          </tr>
          <tr>
            <td>{{ 'DRIVER_IMPORT.detail' | translate }}:</td>
            <td class="padding-l-15">
              <span>{{ validationErrorsCount }} {{ 'DRIVER_IMPORT.recordsFailed' | translate }}</span>
              <a *ngIf="details.fileEndpoint.validationErrors" class="link" (click)="downloadFile(downloadFileType.ValidationErrors)"> {{ 'DRIVER_IMPORT.link' | translate }} </a>
              <a *ngIf="!details.fileEndpoint.validationErrors && details.fileEndpoint.validationErrorsJson" class="link" (click)="downloadFile(downloadFileType.ValidationErrorsJson)"> {{ 'DRIVER_IMPORT.link' | translate }} </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="file-processing"
      *ngIf="
      jobStatus === 'PROVISION_ENQUEUING' ||
      jobStatus === 'PROVISION_IN_PROGRESS' ||
        jobStatus === 'COMPLETED_SUCCESSFULLY' ||
        jobStatus === 'COMPLETED_WITH_PROVISION_ERROR'
      "
    >
      <h4 class="details-body-header">{{ 'DRIVER_IMPORT.fileProcessing' | translate }}</h4>
      <table>
        <tbody>
          <tr>
            <td>{{ 'DRIVER_IMPORT.status' | translate }} :</td>
            <td class="padding-l-15">
              <ng-container *ngIf="jobStatus === 'PROVISION_IN_PROGRESS' || jobStatus === 'PROVISION_ENQUEUING'">{{
                'DRIVER_IMPORT.inProgress' | translate
              }}</ng-container>
              <ng-container *ngIf="jobStatus === 'COMPLETED_SUCCESSFULLY'">{{
                'DRIVER_IMPORT.completedSuccessfully' | translate
              }}</ng-container>
              <ng-container *ngIf="jobStatus === 'COMPLETED_WITH_PROVISION_ERROR'">{{
                'DRIVER_IMPORT.completedWithProvisonError' | translate
              }}</ng-container>
            </td>
          </tr>

          <tr>
            <td>{{ 'DRIVER_IMPORT.statusDetail' | translate }} :</td>
            <td class="padding-l-15">
              <div flexLayout="row" fxLayoutAlign="flex-start center">
                <mat-progress-bar
                  mode="determinate"
                  [value]="(processedRecords / totalRecordsCount) * 100"
                ></mat-progress-bar>
                <span class="padding-l-5"
                  >{{ processedRecords }} / {{ totalRecordsCount }}
                  {{ 'DRIVER_IMPORT.recordsProcessed' | translate }}</span
                >
              </div>
            </td>
          </tr>

          <tr   *ngIf="jobStatus === 'COMPLETED_WITH_PROVISION_ERROR'">
            <td>{{ 'DRIVER_IMPORT.errorsOccured' | translate }} :</td>
            <td class="padding-l-15">
              {{ processedErrorCount }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- File Processing Error Section -->
    <div class="processing-errors" *ngIf="processingErrors.length > 0">
      <h4 class="details-body-header">{{ 'DRIVER_IMPORT.processingErrors' | translate }}</h4>
      <p>
        {{ 'DRIVER_IMPORT.processingErrorsInfo' | translate }}
      </p>

      <table class="download-table">
        <thead>
          <tr>
            <th align="left">{{ 'DRIVER_IMPORT.createdAt' | translate }}</th>
            <th align="left">{{ 'DRIVER_IMPORT.operationType' | translate }}</th>
            <th align="left">{{ 'DRIVER_IMPORT.errorMessages' | translate }}</th>
            <th align="left">{{ 'DRIVER_IMPORT.originalRow' | translate }}</th>
            <th align="left">{{ 'DRIVER_IMPORT.originalRowNumber' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let error of processingErrors">
            <tr>
              <td class="padding-5">{{ error.createdAt }}</td>
              <td class="padding-5">{{ error.operationType }}</td>
              <td class="padding-5">{{ error.errorMessages }}</td>
              <td class="padding-5">{{ error.originalRow }}</td>
              <td class="padding-5">{{ error.originalRowNumber }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
